module.exports = __webpack_public_path__ + "static/media/memories_16.33d768d7.jpg";